import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateGDData, postGDAttachment } from "../Actions/GDNewEditItem";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import $ from "jquery";
toast.configure();
class GDEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            GDPostArray: { 
                supplierMaterialDeclarationId: 0, 
                companyName: '', 
                attachmentName: '', 
                attachmentGuid: '', 
                attachmentId: '', 
                modifiedBy: '', 
                isDeleted: false 
            },
            file: '',
        }
        this.UpdateGDData = this.UpdateGDData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
    }
    // static getDerivedStateFromProps(nextProps, prevState) {
    //     ;
    //     const { dispatch } = nextProps;
    //     if (nextProps.arraylist !== prevState.arraylist) {
    //         prevState.arraylist = nextProps.arraylist;
    //         prevState.GDPostArray.supplierMaterialDeclarationId = nextProps.arraylist.supplierMaterialDeclarationId;
    //         prevState.GDPostArray.companyName = nextProps.arraylist.companyName;
    //         if (nextProps.arraylist.hasOwnProperty("GDattachmentDTOs")) {
    //             if (nextProps.arraylist.GDattachmentDTOs.length > 0) {
    //                 prevState.GDPostArray.attachmentId = nextProps.arraylist.GDattachmentDTOs[0].attachmentId;
    //                 prevState.GDPostArray.attachmentName = nextProps.arraylist.GDattachmentDTOs[0].attachmentName;
    //                 prevState.GDPostArray.attachmentGuid = nextProps.arraylist.GDattachmentDTOs[0].attachmentGuid;
    //             }
    //         }
    //         prevState.GDPostArray.modifiedBy = nextProps.userDisplayName;
    //     }
    //     if (nextProps.GDAttachmentData !== '' && nextProps.GDAttachmentData !== prevState.GDAttachmentData) {
    //         prevState.GDAttachmentData = nextProps.GDAttachmentData;
    //         prevState.GDPostArray.attachmentName = nextProps.GDAttachmentData.FileName;
    //         prevState.GDPostArray.attachmentGuid = nextProps.GDAttachmentData.Guid;
    //         dispatch(updateGDData(prevState.GDPostArray));
    //         dispatch({ type: 'IsGDEdit', data: false });
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { arraylist, dispatch, GDAttachmentData } = nextProps;

        console.log(GDAttachmentData);
        console.log(arraylist);
        if (arraylist && arraylist !== "") {
            prevState.GDPostArray.genericDeclarationId = arraylist.genericDeclarationId;
            prevState.GDPostArray.companyName = arraylist.companyName;
            prevState.GDPostArray.modifiedBy = nextProps.userDisplayName;
            prevState.GDPostArray.attachmentName = arraylist.attachmentName;
            prevState.GDPostArray.attachmentGuid = arraylist.attachmentGuid;
            prevState.GDPostArray.attachmentId = arraylist.attachmentId;
            dispatch({ type: "IsGDEdit", data: '' });
            // prevState.fileName = arraylist.attachmentName;
            // dispatch({ type: "IsGDEdit", data: null });
        }
        if (GDAttachmentData) {
            prevState.GDPostArray.attachmentName = GDAttachmentData.FileName;
            prevState.GDPostArray.attachmentGuid = GDAttachmentData.Guid;
            prevState.file = ''
        }
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "fileName") {
            e.target.files[0].name.trim() !== "" ? $("#GDNFileEditErrMsg").text("") : $("#GDNFileEditErrMsg").text("This field is required");
            this.state.GDPostArray.attachmentName = e.target.files[0].name;
            this.state.file = e.target.files[0];
            this.setState({ GDPostArray: this.state.GDPostArray });
            this.props.dispatch(postGDAttachment(e.target.files[0]))
        } else {
            e.target?.value.trim() !== "" ?  $("#GDNNameEditErrMsg").text("") : $("#GDNNameEditErrMsg").text("This field is required");
            this.state.GDPostArray[nodeName] = e.target.value;
            this.setState({});
        }
    }

    UpdateGDData(){
        const { dispatch, history } = this.props;
        if (this.state.GDPostArray.attachmentName.trim() == "" || this.state.GDPostArray.companyName.trim() == ""){
            this.state.GDPostArray.companyName.trim() == "" ? $("#GDNNameEditErrMsg").text("This field is required") : $("#GDNNameEditErrMsg").text("");
            this.state.GDPostArray.attachmentName.trim() == "" ? $("#GDNFileEditErrMsg").text("This field is required") : $("#GDNFileEditErrMsg").text("");
        } else {
            $("#GDNNameEditErrMsg").text("");
            $("#GDNFileEditErrMsg").text("");
            dispatch(updateGDData(this.state.GDPostArray));
            history.goBack()
        }
            // this.props.dispatch({ type: 'IsGDEdit', data: null });
            // this.props.history.push("/Home/GDLibray")
    }

    ClearInput() {
    let clearData = { FileName: "", Guid: "" }
        this.props.dispatch({
            type: "GDAttchmentUploadSuccess",
            data: clearData,
        })
        $("#GDNFileEditErrMsg").text("This field is required")
    }

    CancelGD() {
        this.props.history.push("/Home/GDLibray");
        this.props.dispatch({ type: 'IsGDEdit', data: false });
        this.props.dispatch({ type: "GDEditing", data: false })
    }
    render() {

        return (
            <div className="full-height w-100">
                <div className="grey-bg  course-list-page pt-3">
                    <div className="px-4">
                        <div className="panel-box search-filter-box mb-4">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="form-label required" >Company Name</label><br></br>
                                    <input className="form-control" type="text" id="companyname" name="companyName" onChange={(e) => this.handleInputChange(e)} value={this.state.GDPostArray.companyName}></input>
                                    <span id="GDNNameEditErrMsg" className="spanErrMsg ml-2"></span>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label required" >File</label><br></br>
                                    {/* <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Browse File<input type="file" id="files" name="fileName" title=" " onChange={(e) => this.handleInputFileChange(e)} /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="" name="username" value={this.state.GDPostArray.attachmentName} />
                                        {
                                            this.state.GDPostArray.attachmentName ? <div class="input-group-append">
                                                <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                            </div> : ''
                                        }

                                    </div> */}
                                    <div class="input-group ">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Browse File<input type="file" id="files"  style={{ marginRight: 40 }} name="fileName" onChange={e => this.handleInputChange(e)}
                                                onClick={(event) => { event.currentTarget.value = null }}
                                            /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="No file chosen" value={this.state.GDPostArray.attachmentName} />
                                        {
                                            this.state.GDPostArray.attachmentName ?
                                            <div class="input-group-append" style={{cursor:"pointer"}}>
                                                <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                            </div> : ''
                                        }
                                    </div>
                                    <span id="GDNFileEditErrMsg" className="spanErrMsg ml-2"></span>
                                </div>
                                <div className="col-lg-12 py-3">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.UpdateGDData()}> Update </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelGD()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {

    return {
        arraylist: state.SidePanReducer.IsGDEdit,
        userDisplayName: state.SidePanReducer.userDisplayName,
        GDAttachmentData: state.SidePanReducer.GDAttachmentData,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GDEdit));